import React, { FC } from 'react';

export const Registration: FC = () => {
  return <div>Should be implemented</div>;
};
